import { render, staticRenderFns } from "./directReportee.vue?vue&type=template&id=e55f4292&scoped=true"
import script from "./directReportee.vue?vue&type=script&lang=js"
export * from "./directReportee.vue?vue&type=script&lang=js"
import style0 from "./directReportee.vue?vue&type=style&index=0&id=e55f4292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55f4292",
  null
  
)

export default component.exports